/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { breakpointCodes } from 'rp-mq-breakpoints';
// eslint-disable-line import/no-named-as-default
import NewsStories from './components/NewsStories';
import NewsError from './components/NewsError';

const { NARROW, EXTRA_NARROW, MEDIUM, WIDE, EXTRA_WIDE } = breakpointCodes;
const AD_POSITIONS = [
    { ad: 2, position: 27, mq: [NARROW, EXTRA_NARROW, MEDIUM, WIDE, EXTRA_WIDE] },
    { ad: 3, position: 45, mq: [EXTRA_NARROW] },
    { ad: 4, position: 28, mq: [EXTRA_WIDE] },
    { ad: 6, position: 29, mq: [EXTRA_WIDE] },
    { ad: 9, position: 30, mq: [EXTRA_WIDE] },
    { ad: 5, position: 31, mq: [MEDIUM, WIDE] },
];

/**
 * Component that is used for rendering <News />
 * @param storiesList
 * @param advertisement
 */
function News(props) {
    return (
        props.storiesList.length > 0 ?
            <NewsStories
                {...props}
                adPositions={AD_POSITIONS}
            /> : <NewsError />
    );
}

News.propTypes = {
    /**
     * List of news
     */
    storiesList: PropTypes.arrayOf(

        PropTypes.shape({
            /**
             * News id
             */
            id: PropTypes.oneOfType([
                PropTypes.number,
                PropTypes.string,
            ]).isRequired,
            /**
             * News url
             */
            url: PropTypes.string,
            /**
             * News image
             */
            image: PropTypes.object,
            /**
             * News could be free or not
             */
            isFree: PropTypes.bool.isRequired,
            /**
             * News could be live blog or not
             */
            isLive: PropTypes.bool,
            /**
             * News sections
             */
            section: PropTypes.string,
            /**
             * News label
             */
            label: PropTypes.string,
            /**
             * News with video
             */
            videoIncluded: PropTypes.bool,
            /**
             * News with audio
             */
            audioIncluded: PropTypes.bool,
            /**
             * News headline
             */
            headline: PropTypes.string,
        })
    ).isRequired,
};

const mapStateToProps = ({ news: { storiesList, advertisement }, newsTitle }) => ({
    storiesList,
    advertisement,
    newsTitle,
});

const ConnectedNews = connect(mapStateToProps)(News);

export {
    News,
    ConnectedNews as default
};



// WEBPACK FOOTER //
// ./src/js/News/News.js